// extracted by mini-css-extract-plugin
export default {"messageGroup":"MessageGroup_messageGroup__I-NvQ"};